import GlobalAxios from "../../axios/axios-config";
import { ISelectType } from "../../components/UI/Inputs/AutoComplete";
import {
  IAvaiableDates,
  IAvaiableSchedule,
  ICalendarCancellationParams,
  ICancelationReason,
  IConsulationScheduleAppointment,
  IExamAvaiableDatesParams,
  IExamScheduleAppointment,
  IGetConsultationAvaiableDatesParams,
  IGetConsultationAvaiableScheduleParams,
  IGetExamAvaiableScheduleParams,
  IGroupExam,
  IICalendarConsultationScheduleConfirmationParams,
  IIICalendarExamScheduleConfirmationParams,
  IIScheduleConsultationParams,
  IProfessional,
  IProfessionalSearchParams,
  ISchedule,
  IScheduleList,
  ISpeciality,
} from "./model";
import {
  ICalendarAvailableBotStatus,
  ICalendarConsultationAvailableBot,
  ICalendarExamAvailableBot,
} from "../ScheduleNew/NewScheduleFlow/models";

const TASY_SCHEDULE_ROUTE =
  process.env.REACT_APP_CALENDAR +
  "/api/v1/tasy/CalendarConsultationExamScheduleAppointment";

export class ScheduleAppointmentService {
  public static get = (historic: boolean) => {
    return GlobalAxios.get<ISchedule[]>(TASY_SCHEDULE_ROUTE, {
      params: { historic },
    });
  };

  public static getList = (historic: boolean) => {
    return GlobalAxios.get<IScheduleList>(`${TASY_SCHEDULE_ROUTE}/list`, {
      params: { historic },
    });
  };

  public static getTypes = () => {
    return GlobalAxios.get<ISelectType[]>(
      process.env.REACT_APP_MAIN + "/api/v1/Generic/list",
      {
        params: {
          Identifier: "TasySchedulingType",
        },
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  };

  public static getPeriodOptions = () => {
    return GlobalAxios.get<ISelectType[]>(
      process.env.REACT_APP_MAIN + "/api/v1/Generic/list",
      {
        params: {
          Identifier: "ScheduleShiftCode",
        },
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  };

  public static getSpecialitys = () => {
    return GlobalAxios.get<ISpeciality[]>(
      process.env.REACT_APP_CALENDAR + "/api/v1/MedicalSpecialty/List"
    );
  };

  public static getProfessionals = (params: IProfessionalSearchParams) => {
    return GlobalAxios.get<IProfessional[]>(
      process.env.REACT_APP_CALENDAR +
        "/api/v1/tasy/CalendarConsultationRegister",
      { params }
    );
  };

  public static getExamGroups = () => {
    return GlobalAxios.get<IGroupExam[]>(
      process.env.REACT_APP_CALENDAR +
        "/api/v1/tasy/CalendarExamGroupingRegister"
    );
  };

  public static getSpecialitysTasy2 = (params: {
    IndividualId: string;
    InsuranceIdentifier: number;
    InsuranceCategoryCode?: string;
    EstablishmentCode?: string;
  }) => {
    return GlobalAxios.get<
      {
        identifier: number;
        name: string;
      }[]
    >(
      process.env.REACT_APP_CALENDAR +
        "/api/v1/tasy_2/CalendarSpecialtyConsultationWeb",
      { params }
    );
  };

  public static getCalendarPreferencesBySpecialtyTasy2 = (params: {
    TicketAutomationReceivedRuleId?: string;
    MedicalSpecialtyExternalId: number;
    IndividualId: string;
    InsuranceIdentifier: number;
    InsuranceCategoryCode?: string;
    EstablishmentCode?: string;
  }) => {
    return GlobalAxios.get<
      {
        identifier: number;
        preference: string;
      }[]
    >(
      process.env.REACT_APP_CALENDAR +
        "/api/v1/tasy_2/CalendarPreferencesBySpecialty",
      { params }
    );
  };

  public static getProfessionalsTasy2 = (params: {
    IndividualId: string;
    InsuranceIdentifier: number;
    InsuranceCategoryCode?: string;
    EstablishmentCode?: string;
    MedicalSpecialtyCode: number;
    TasyScheduleTypeCode: number;
    CalendarPreference?: string;
  }) => {
    return GlobalAxios.get<
      {
        identifier: number;
        individualName: string;
        calendarName: string;
      }[]
    >(process.env.REACT_APP_CALENDAR + "/api/v1/tasy_2/CalendarRegister", {
      params,
    });
  };

  public static getCalendarRegisterHasTurnTasy2 = (params: {
    MedicalSpecialtyCode: number;
    Identifier: number;
    EstablishmentCode?: string;
  }) => {
    return GlobalAxios.get<
      {
        identifier: number;
        calendarName: string;
        individualName: string;
      }[]
    >(
      process.env.REACT_APP_CALENDAR +
        "/api/v1/tasy_2/CalendarRegisterHasTurn",
      { params }
    );
  };

  public static getSchedulePriceTasy2 = (params: {
    ticketAutomationReceivedRuleId: string;
    tasyScheduleTypeCode: number;
    insuranceCode: number;
    insuranceCategoryCode?: string;
    establishmentCode?: string;
    medicalSpecialtyCode?: number;
    calendarIdentifier?: number;
    procedureCode?: number;
    procedureOriginCode?: number;
    procedureInternalCode?: number;
  }) => {
    return GlobalAxios.get<{
      price?: number | null;
      procedureCode?: number | null;
      procedureOriginCode?: number | null;
      procedureInternalCode?: number | null;
    }>(process.env.REACT_APP_CALENDAR + "/api/v1/tasy_2/SchedulePrice", {
      params,
    });
  };

  public static getInternalProcedureOrientationTasy2 = (params: {
    ProcedureInternalCode: number;
  }) => {
    return GlobalAxios.get<{ orientation?: string | null }>(
      process.env.REACT_APP_CALENDAR +
        "/api/v1/tasy_2/InternalProcedureOrientation",
      { params }
    );
  };

  public static getInternalProcedureGuidanceForInsuranceTasy2 = (params: {
    InternalProcedureCode: number;
    InsuranceCode: number;
  }) => {
    return GlobalAxios.get<{ orientation?: string | null }>(
      process.env.REACT_APP_CALENDAR +
        "/api/v1/tasy_2/InternalProcedureGuidanceForInsurance",
      { params }
    );
  };

  public static getExamGroupsTasy2 = (params?: { EstablishmentCode?: string }) => {
    return GlobalAxios.get<
      {
        identifier: number;
        name: string;
      }[]
    >(
      process.env.REACT_APP_CALENDAR +
        "/api/v1/tasy_2/CalendarExamGroupingWeb",
      { params }
    );
  };

  public static getExamProceduresTasy2 = (params: {
    IndividualId: string;
    InsuranceIdentifier: number;
    InsuranceCategoryCode?: string;
    EstablishmentCode?: string;
    CalendarGroupingIdentifier: number;
  }) => {
    return GlobalAxios.get<
      {
        procedureCode: number;
        procedureExamName: string;
        procedureInternalCode: number;
        procedureOriginType: number;
        calendarIdentifiers: number[];
      }[]
    >(
      process.env.REACT_APP_CALENDAR +
        "/api/v1/tasy_2/CalendarExamProcedureWeb",
      { params }
    );
  };

  public static getCalendarReturnAvaiablesTasy2 = (params: {
    IndividualId: string;
    TicketAutomationReceivedRuleId: string;
    EstablishmentCode?: string;
  }) => {
    return GlobalAxios.get<
      {
        identifier: number;
        pacientName: string;
        physicianNameExecute: string;
        calendarName: string;
        descriptionSite: string | null;
        calendarDate: string;
        calendarStartDate: string;
        calendarStatusName: string;
        tasyScheduleTypeName: string;
        calendarIdentifier: number;
        medicalSpecialtyCode: number;
        medicalSpecialtyName: string;
        insuranceCode?: number;
        insuranceName?: string;
        insuranceCategoryCode?: string;
        insuranceCategoryName?: string;
      }[]
    >(
      process.env.REACT_APP_CALENDAR +
        "/api/v1/tasy_2/CalendarReturnAvaiables",
      { params }
    );
  };

  public static createConsultationAvailableBotTasy2 = (params: {
    individualId: string;
    ticketAutomationReceivedRuleId: string;
    insuranceIdentifier: number;
    insuranceCategoryCode?: string;
    establishmentCode?: string;
    medicalSpecialtyCode?: number;
    calendarIdentifier?: number;
    calendarPreference?: string;
    calendarDateStart?: string;
    scheduleShiftCodeList?: string[];
  }) => {
    return GlobalAxios.post<{ identifier: number }>(
      process.env.REACT_APP_CALENDAR +
        "/api/v1/tasy_2/CalendarConsultationAvailableBot",
      params
    );
  };

  public static getConsultationAvailableBotTasy2 = (params: {
    CalendarControlId: number;
  }) => {
    return GlobalAxios.get<ICalendarConsultationAvailableBot[]>(
      process.env.REACT_APP_CALENDAR +
        "/api/v1/tasy_2/CalendarConsultationAvailableBot",
      { params }
    );
  };

  public static getConsultationAvailableBotStatusTasy2 = (params: {
    CalendarControlId: number;
  }) => {
    return GlobalAxios.get<ICalendarAvailableBotStatus>(
      process.env.REACT_APP_CALENDAR +
        "/api/v1/tasy_2/CalendarConsultationAvailableBot/status",
      { params }
    );
  };

  public static createExamAvailableBotTasy2 = (params: {
    individualId: string;
    ticketAutomationReceivedRuleId: string;
    insuranceIdentifier: number;
    insuranceCategoryCode?: string;
    establishmentCode?: string;
    internalProcedureCode?: number;
    procedureCode?: number;
    procedureOriginCode?: number;
    calendarIdentifierList?: number[];
    calendarDateStart?: string;
    scheduleShiftCodeList?: string[];
  }) => {
    return GlobalAxios.post<{ identifier: number }>(
      process.env.REACT_APP_CALENDAR +
        "/api/v1/tasy_2/CalendarExamAvailableBot",
      params
    );
  };

  public static getExamAvailableBotTasy2 = (params: {
    CalendarControlId: number;
  }) => {
    return GlobalAxios.get<ICalendarExamAvailableBot[]>(
      process.env.REACT_APP_CALENDAR +
        "/api/v1/tasy_2/CalendarExamAvailableBot",
      { params }
    );
  };

  public static getExamAvailableBotStatusTasy2 = (params: {
    CalendarControlId: number;
  }) => {
    return GlobalAxios.get<ICalendarAvailableBotStatus>(
      process.env.REACT_APP_CALENDAR +
        "/api/v1/tasy_2/CalendarExamAvailableBot/status",
      { params }
    );
  };

  public static getConsultationAvaiableDate = (
    params: IGetConsultationAvaiableDatesParams
  ) => {
    return GlobalAxios.get<IAvaiableDates>(
      process.env.REACT_APP_CALENDAR +
        "/api/v1/tasy/CalendarConsultationAvailable/Dates",
      {
        params,
        paramsSerializer: {
          indexes: null,
        },
      }
    );
  };

  public static getConsultationAvaiableSchedules = (
    params: IGetConsultationAvaiableScheduleParams
  ) => {
    return GlobalAxios.get<IAvaiableSchedule[]>(
      process.env.REACT_APP_CALENDAR +
        "/api/v1/tasy/CalendarConsultationAvailable/Schedules",
      {
        params,
        paramsSerializer: {
          indexes: null,
        },
      }
    );
  };

  public static getExamAvaiableDate = (params: IExamAvaiableDatesParams) => {
    return GlobalAxios.get<IAvaiableDates>(
      process.env.REACT_APP_CALENDAR +
        "/api/v1/tasy/CalendarExamAvailable/Dates",
      {
        params,
        paramsSerializer: {
          indexes: null,
        },
      }
    );
  };

  public static getExamAvaiableSchedules = (
    params: IGetExamAvaiableScheduleParams
  ) => {
    return GlobalAxios.get<IAvaiableSchedule[]>(
      process.env.REACT_APP_CALENDAR +
        "/api/v1/tasy/CalendarExamAvailable/Schedules",
      {
        params,
        paramsSerializer: {
          indexes: null,
        },
      }
    );
  };

  public static calendarConsultationScheduling = (
    params: IIScheduleConsultationParams
  ) => {
    return GlobalAxios.put<{ id: string }>(
      process.env.REACT_APP_CALENDAR +
        "/api/v1/tasy/CalendarConsultationScheduling",
      params,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  };

  public static calendarExamScheduling = (
    params: IIScheduleConsultationParams
  ) => {
    return GlobalAxios.put<{ id: string }>(
      process.env.REACT_APP_CALENDAR + "/api/v1/tasy/CalendarExamScheduling",
      params,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  };

  public static calendarConsultationSchedulingTasy2 = (params: {
    identifier: number;
    individualId: string;
    ticketAutomationReceivedRuleId: string;
    insuranceCode: number;
    insuranceCategoryCode?: string;
    establishmentCode?: string;
  }) => {
    return GlobalAxios.post<{ id: string; identifier: number }>(
      process.env.REACT_APP_CALENDAR +
        "/api/v1/tasy_2/CalendarConsultationScheduling",
      params
    );
  };

  public static calendarExamSchedulingTasy2 = (params: {
    identifier: number;
    individualId: string;
    ticketAutomationReceivedRuleId: string;
    insuranceCode: number;
    insuranceCategoryCode?: string;
    establishmentCode?: string;
    internalProcedureCode: number;
    minutesDuration: number;
    scheduleAttachmentIds?: string[];
  }) => {
    return GlobalAxios.post<{ id: string; identifier: number }>(
      process.env.REACT_APP_CALENDAR + "/api/v1/tasy_2/CalendarExamScheduling",
      params
    );
  };

  public static getScheduleAttachmentRules = (params: {
    ticketAutomationReceivedRuleId: string;
    calendarIdentifier?: number;
    insuranceCode?: number;
    insuranceTypeCode?: number;
    procedureInternalCode?: number;
    calendarPreferencesGrouped?: string;
  }) => {
    return GlobalAxios.get<
      {
        id: string;
        displayOrder: number;
        message: string;
        messageError?: string;
      }[]
    >(process.env.REACT_APP_CALENDAR + "/api/v1/ScheduleAttachment/Rules", {
      params,
    });
  };

  public static createScheduleAttachment = (params: {
    calendarExamIdentifier: string;
    mediaFilesIds: string[];
    establishmentId?: string;
    deleteMediaFilesIds?: string[];
  }) => {
    return GlobalAxios.post<{ id: string }>(
      process.env.REACT_APP_CALENDAR + "/api/v1/ScheduleAttachment",
      params
    );
  };

  public static getConsulationScheduleAppointment = (
    request: { identifier: number; ticketAutomationReceivedRuleId?: string | null }
  ) => {
    return GlobalAxios.get<IConsulationScheduleAppointment>(
      process.env.REACT_APP_CALENDAR +
        "/api/v1/tasy/CalendarConsultationScheduleAppointment",
      {
        params: request,
      }
    );
  };

  public static getExamScheduleAppointment = (
    request: { identifier: number; ticketAutomationReceivedRuleId?: string | null }
  ) => {
    return GlobalAxios.get<IExamScheduleAppointment>(
      process.env.REACT_APP_CALENDAR +
        "/api/v1/tasy/CalendarExamScheduleAppointment",
      {
        params: request,
      }
    );
  };

  public static getCalendarExamCancellationReason = () => {
    return GlobalAxios.get<ICancelationReason[]>(
      process.env.REACT_APP_CALENDAR +
        "/api/v1/tasy/CalendarExamCancellationReason"
    );
  };

  public static getCalendarConsultationCancellationReason = () => {
    return GlobalAxios.get<ICancelationReason[]>(
      process.env.REACT_APP_CALENDAR +
        "/api/v1/tasy/CalendarConsultationCancellationReason"
    );
  };

  public static calendarConsultationScheduleCancellation = (
    params: ICalendarCancellationParams
  ) => {
    return GlobalAxios.put<{ id: string }>(
      process.env.REACT_APP_CALENDAR +
        "/api/v1/tasy/CalendarConsultationScheduleCancellation",
      params
    );
  };

  public static calendarExamScheduleCancellation = (
    params: ICalendarCancellationParams
  ) => {
    return GlobalAxios.put<{ id: string }>(
      process.env.REACT_APP_CALENDAR +
        "/api/v1/tasy/CalendarExamScheduleCancellation",
      params
    );
  };

  public static calendarConsultationScheduleConfirmation = (
    params: IICalendarConsultationScheduleConfirmationParams
  ) => {
    return GlobalAxios.put<{ id: string }>(
      process.env.REACT_APP_CALENDAR +
        "/api/v1/tasy/CalendarConsultationScheduleConfirmation",
      params,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  };

  public static calendarExamScheduleConfirmation = (
    params: IIICalendarExamScheduleConfirmationParams
  ) => {
    return GlobalAxios.put<{ id: string }>(
      process.env.REACT_APP_CALENDAR +
        "/api/v1/tasy/CalendarExamScheduleConfirmation",
      params,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  };
}
